
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.998 30.001c6.628 0 12-5.373 12-12s-5.372-12-12-12c-6.627 0-12 5.373-12 12s5.373 12 12 12zm0 3c8.285 0 15-6.716 15-15 0-8.284-6.715-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.001 21.804L21.589 18l-6.588-3.804v7.608zm8.088-1.206c2-1.155 2-4.042 0-5.196l-6.588-3.804c-2-1.155-4.5.288-4.5 2.598v7.608c0 2.309 2.5 3.752 4.5 2.598l6.588-3.804z","fill":"currentColor"}})])
          )
        }
      }
    